<div class="d-flex align-items-center mb-3">
  <div class="h3">{{'company_details_header' | i18next}}</div>
</div>
<app-company-navigation></app-company-navigation>
<div class="card card-nb">
  <div class="card-body">
    <h3>{{'payment_details_form_header' | i18next}}</h3>
    <app-sepa-form [bankAccount]="bankAccount" (formSubmit)="onUpdate($event)"></app-sepa-form>
  </div>
</div>
